import { render, staticRenderFns } from "./ConfigSyncHtttnUpdate.vue?vue&type=template&id=35b0117d"
import script from "./ConfigSyncHtttnUpdate.vue?vue&type=script&lang=js"
export * from "./ConfigSyncHtttnUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports